var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "advise-map", attrs: { "align-h": "end" } },
    [
      _c(
        "b-col",
        { attrs: { sm: "5", "align-self": "end" } },
        [
          _c("b-alert", { attrs: { variant: _vm.variantdata, show: "" } }, [
            _c("i", {
              staticClass: "fa fa-info-circle",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v("\n      " + _vm._s(_vm.mess) + "\n      ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { lg: "4" } },
        [
          !_vm.view
            ? _c(
                "b-button",
                {
                  attrs: { pressed: _vm.clicked == "add" ? true : false },
                  on: { click: _vm.add }
                },
                [_vm._v("Dibujar área")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.view
            ? _c(
                "b-button",
                {
                  attrs: { pressed: _vm.clicked == "select" ? true : false },
                  on: { click: _vm.select }
                },
                [_vm._v("Seleccionar área")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.view
            ? _c(
                "b-button",
                {
                  attrs: { pressed: _vm.clicked == "cancel" ? true : false },
                  on: { click: _vm.cancel }
                },
                [_vm._v("Cancelar")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { pressed: _vm.clicked == "accept" ? true : false },
              on: { click: _vm.accept }
            },
            [_vm._v("Aceptar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Area.vue?vue&type=template&id=af8b7950&
// module id = null
// module chunks = 